export class CallDetails {
    public kom_call_id: number;
    public report_date: any;
    public node_id: number;
    public node_name: string;
    public track_node: number;
    public dept: string;
    public call_type: string;
    public transfer_group: string;
    public eaid: number;
    public queue_time: number;
    public talk_time: number;
    public hold_time: number;
    public crc_first_name: string;
    public crc_last_name: string;
    public nco: number;
    public nch: number;
    public aba: number;
    public aht: number;
    public nto: number;
    public lang: string;
    public inbound_outbound_call_flag: string;
    public extn_nbr: number;
    public local_termination_time_id: number;
    public call_end_time: any;
    public call_start_time: any;
    public pr_status_id: number;
    public sales_rep_id: string;
    public sc_emp_id: number;
    public day_part: any;
    public kom_last_modified_date: any;
    public load_date: any;
    public network_id: string;
    public feedFromDt: Date;
    public feedToDt: Date;
    constructor() {
        this.kom_call_id = null;
        this.report_date = null;
        this.node_id = null;
        this.node_name = null;
        this.track_node = null;
        this.dept = null;
        this.call_type = null;
        this.transfer_group = null;
        this.eaid = null;
        this.queue_time = null;
        this.talk_time = null;
        this.hold_time = null;
        this.crc_first_name = null;
        this.crc_last_name = null;
        this.nco = null;
        this.nch = null;
        this.aba = null;
        this.aht = null;
        this.nto = null;
        this.lang = null;
        this.inbound_outbound_call_flag = null;
        this.extn_nbr = null;
        this.local_termination_time_id = null;
        this.call_end_time = null;
        this.call_start_time = null;
        this.pr_status_id = null;
        this.sales_rep_id = null;
        this.sc_emp_id = null;
        this.day_part = null;
        this.kom_last_modified_date = null;
        this.load_date = null;
        this.network_id = null;
        this.feedFromDt = null;
        this.feedToDt = null;
    }
}
